module.exports = __webpack_public_path__ + "img/big_1_42.53853d0f.png";